import * as Sentry from '@sentry/browser'
import { initialState } from './index'
import { ACCOUNT_TYPE_CORPORATE, CURRENT_POLICY_VERSION, VIEW_ADVERTISER, VIEW_EMPLOYER } from '../../../constants'
import { getProfile, getRatingsGiven, getRatingsReceived, getToken, updatePolicy } from '../../../services/users'
import { trackEvent } from '../../../utils/analytics'
import { getUserCategory } from '../../../utils/user'
import { STORAGE_KEY } from '../../index'

export default {
  authenticate ({ dispatch }) {
    return new Promise((resolve, reject) => {
      let token = getToken()
      if (!token) {
        reject(false)
        return
      }

      getProfile()
        .then(response => {
          let user = response.data
          let view = user.accountType === ACCOUNT_TYPE_CORPORATE ? VIEW_EMPLOYER : ''
          dispatch('setUserData', { token, user, view })
          resolve(true)
        })
        .catch(reject)
    })
  },

  setUserData ({ state, commit }, { token, user, view }) {
    if (view) {
      commit('setView', { view })
    }
    commit('setToken', { token })
    commit('setUser', { user: Object.assign({}, initialState.user, user) })
    commit('setIsAuthenticated', { isAuthenticated: true })

    trackEvent({
      userId: user.id,
      userCategory: getUserCategory({
        isAdvertiserView: state.view === VIEW_ADVERTISER,
        isCorporation: state.user.accountType === ACCOUNT_TYPE_CORPORATE
      })
    })

    Sentry.setUser({
      id: user.id,
      email: user.email
    })
  },

  logout ({ commit }) {
    commit('setView', { view: VIEW_ADVERTISER })
    commit('setToken', { token: null })
    commit('setUser', { user: Object.assign({}, initialState.user) })
    commit('setIsAuthenticated', { isAuthenticated: false })

    commit('reset')
    commit('resetArena')
    commit('resetStats')
    commit('resetSelectedBidCard')

    window.sessionStorage.removeItem(STORAGE_KEY)

    trackEvent({
      userId: null,
      userCategory: null
    })

    Sentry.configureScope(scope => scope.setUser(null))
  },

  updatePolicy ({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      updatePolicy(id, data)
        .then(() => {
          commit('setAcceptedPolicyVersion', { acceptedPolicyVersion: CURRENT_POLICY_VERSION })
          commit('setSubscribeToNewsletter', { subscribeToNewsletter: data.subscribeToNewsletter })

          resolve()
        })
        .catch(reject)
    })
  },

  getRatingsReceived ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getRatingsReceived(id)
        .then(response => {
          let ratings = response.data
          commit('setRatingsReceived', { ratings })
          resolve(ratings)
        })
        .catch(reject)
    })
  },

  getRatingsGiven ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getRatingsGiven(id)
        .then(response => {
          let ratings = response.data
          commit('setRatingsGiven', { ratings })
          resolve(ratings)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js